import { Badge } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import { buildStatusConfig } from '../../constants';
import type { FocusGroupTableData } from '../../types';

interface FocusGroupStatusChipProps {
  status: FocusGroupTableData['status'];
}

export const FocusGroupStatusChip = ({ status }: FocusGroupStatusChipProps) => {
  const { t } = useTranslation('audiences');
  const config = buildStatusConfig(t)[status];

  return (
    <Badge variant={config.variant} roundness="full">
      {config.label}
    </Badge>
  );
};
